const publicUrl = process.env.PUBLIC_URL || '';

export const resolvePublicAssetPath = (path: string): string => {
  if (!path || /^(https?:)?\/\//.test(path) || path.startsWith('data:')) {
    return path;
  }

  if (!path.startsWith('/')) {
    return path;
  }

  if (!publicUrl || publicUrl === '/') {
    return path;
  }

  const normalizedPublicUrl = publicUrl.endsWith('/')
    ? publicUrl.slice(0, -1)
    : publicUrl;

  if (normalizedPublicUrl === '.') {
    return `.${path}`;
  }

  return `${normalizedPublicUrl}${path}`;
};

export const resolvePublicAssetPaths = <T>(value: T): T => {
  if (typeof value === 'string') {
    return resolvePublicAssetPath(value) as T;
  }

  if (Array.isArray(value)) {
    return value.map(resolvePublicAssetPaths) as T;
  }

  if (value && typeof value === 'object') {
    const resolvedValue: Record<string, unknown> = {};

    for (const key in value) {
      resolvedValue[key] = resolvePublicAssetPaths(value[key]);
    }

    return resolvedValue as T;
  }

  return value;
};
